import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { SettingsService } from '../services/settings.service';

/**
 * Add the template content to the DOM unless the condition is true.
 */
@Directive({ selector: '[requireRole]' })
export class RequireRoleDirective {
    private hasView = false;

    constructor(
        private settings: SettingsService,
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef) { }

    @Input()
    set requireRole(roles: Array<string>) {
        if (this.settings.isInAny(roles) && !this.hasView) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.hasView = true;
        } else if (!this.settings.isInAny(roles) && this.hasView) {
            this.viewContainer.clear();
            this.hasView = false;
        }
    }
}